var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSubir = function SvgSubir(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tachita",
    transform: "translate(51.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    transform: "translate(-51.273)",
    fill: "none",
    stroke: "#e1e1e1",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7910",
    "data-name": "Group 7910",
    transform: "translate(-47.963 6.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M1870.586,361.162a7.206,7.206,0,0,0-.976.066,9.174,9.174,0,0,0-8.413-5.553,9.362,9.362,0,0,0-9.227,8.961,5.836,5.836,0,0,0,.285,11.653h4.613a.648.648,0,0,0,0-1.3h-4.613a4.536,4.536,0,0,1,0-9.069c.1,0,.195,0,.292.01a.638.638,0,0,0,.673-.655l0-.118a8.1,8.1,0,0,1,7.98-8.192,7.941,7.941,0,0,1,7.437,5.217.631.631,0,0,0,.715.4,6.028,6.028,0,0,1,1.236-.128,6.27,6.27,0,0,1,0,12.537h-3.433a.648.648,0,0,0,0,1.3h3.433a7.566,7.566,0,0,0,0-15.127Z",
    transform: "translate(-1846.576 -355.675)",
    fill: "#7b868c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M1869.884,373.627a.648.648,0,0,0-.916,0l-3.066,3.067a.647.647,0,0,0,.915.916l1.956-1.956v10.436a.648.648,0,0,0,1.3,0V375.643l1.966,1.967a.647.647,0,0,0,.916-.916Z",
    transform: "translate(-1853.736 -362.775)",
    fill: "#7b868c"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubir, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Subir.add162c7.svg";
export { ForwardRef as ReactComponent };